export function addSymbolSlash(symbol: string) {
  const { symbolList } = useSymbol()
  const symbolItem = symbolList.value.find(i => i.symbol === symbol)
  return `${symbolItem?.base}/${symbolItem?.quote}` || ''
}
